import React from 'react';
import PropTypes from 'prop-types';

const LoadingFeedPlaceholder = ({ loading }) => (
	loading &&
		<div className="re-overflow-hidden re-loadingfeedplaceholder-container" data-testid="LoadingFeedPlaceholder">
			<div className="re-loadingfeedplaceholder re-container-outer">
				<div className="re-loadingfeedplaceholder-userdetails">
					<div className="re-avatar-sm re-avatar-placeholder"></div>
					<div className="re-loadingfeedplaceholder-user">
						<div className="re-loadingfeedplaceholder-name"></div>
						<div className="re-loadingfeedplaceholder-date"></div>
					</div>
				</div>
				<div className="re-loadingfeedplaceholder-content">
					<div className="re-loadingfeedplaceholder-type"></div>
					<div className="re-loadingfeedplaceholder-country"></div>
				</div>
			</div>

			<div className="re-loadingfeedplaceholder re-container-outer">
				<div className="re-loadingfeedplaceholder-userdetails">
					<div className="re-avatar-sm re-avatar-placeholder"></div>
					<div className="re-loadingfeedplaceholder-user">
						<div className="re-loadingfeedplaceholder-name"></div>
						<div className="re-loadingfeedplaceholder-date"></div>
					</div>
				</div>
				<div className="re-loadingfeedplaceholder-content">
					<div className="re-loadingfeedplaceholder-type"></div>
					<div className="re-loadingfeedplaceholder-country"></div>
				</div>
			</div>

			<div className="re-loadingfeedplaceholder re-container-outer">
				<div className="re-loadingfeedplaceholder-userdetails">
					<div className="re-avatar-sm re-avatar-placeholder"></div>
					<div className="re-loadingfeedplaceholder-user">
						<div className="re-loadingfeedplaceholder-name"></div>
						<div className="re-loadingfeedplaceholder-date"></div>
					</div>
				</div>
				<div className="re-loadingfeedplaceholder-content">
					<div className="re-loadingfeedplaceholder-type"></div>
					<div className="re-loadingfeedplaceholder-country"></div>
				</div>
			</div>

			<div className="re-loadingfeedplaceholder re-container-outer">
				<div className="re-loadingfeedplaceholder-userdetails">
					<div className="re-avatar-sm re-avatar-placeholder"></div>
					<div className="re-loadingfeedplaceholder-user">
						<div className="re-loadingfeedplaceholder-name"></div>
						<div className="re-loadingfeedplaceholder-date"></div>
					</div>
				</div>
				<div className="re-loadingfeedplaceholder-content">
					<div className="re-loadingfeedplaceholder-type"></div>
					<div className="re-loadingfeedplaceholder-country"></div>
				</div>
			</div>
		</div>
)

LoadingFeedPlaceholder.propTypes = {
	loading: PropTypes.bool
};

export default LoadingFeedPlaceholder;
